/* Strains script: a strain opens a panel with a drawn specimen; hint walk (D-0604) */
(function () {
  if (window.__drbStrains) return;
  window.__drbStrains = true;

  function paint(canvas, shape, seed) {
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return;

    var box = canvas.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(box.width * dpr));
    var h = Math.max(1, Math.round(box.height * dpr));
    if (!box.width || !box.height) return;
    canvas.width = w;
    canvas.height = h;

    var s = (seed || 1) % 2147483647;
    if (s <= 0) s += 2147483646;
    function rnd() {
      s = (s * 16807) % 2147483647;
      return (s - 1) / 2147483646;
    }

    var TINTS = {
      green:   { field0: '#21432e', field1: '#0c1e14', glow: 'rgba(150, 240, 190, ', mote: 'rgba(214, 248, 226, ', rod: 158, branch: 150, sat: 52, satNear: 26 },
      plum:    { field0: '#3f1f30', field1: '#1a0a14', glow: 'rgba(240, 170, 205, ', mote: 'rgba(248, 220, 232, ', rod: 338, branch: 330, sat: 52, satNear: 26 },
      neutral: { field0: '#303036', field1: '#0b0b0d', glow: 'rgba(226, 232, 240, ', mote: 'rgba(240, 243, 248, ', rod: 220, branch: 220, sat: 4,  satNear: 8 }
    };
    var ds = (canvas.closest('.drb-strains') || {}).dataset || {};
    var tint = TINTS[ds.specTint] || TINTS.green;

    var g = ctx.createRadialGradient(w * 0.42, h * 0.44, 0, w * 0.5, h * 0.5, Math.max(w, h) * 0.78);
    g.addColorStop(0, tint.field0);
    g.addColorStop(1, tint.field1);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);

    var branch = shape === 'branch';
    var n = Math.round((w * h) / (5200 * dpr)) + 10;

    for (var i = 0; i < n; i++) {
      var x = rnd() * w;
      var y = rnd() * h;
      var near = rnd();
      var len = (branch ? 0.03 : 0.055) * Math.min(w, h) * (0.6 + near * 1.5);
      var thick = len * (branch ? 0.44 : 0.3);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rnd() * Math.PI);
      ctx.shadowColor = tint.glow + (0.5 * near).toFixed(3) + ')';
      ctx.shadowBlur = len * (0.9 + near);
      ctx.fillStyle =
        'hsla(' + (branch ? tint.branch : tint.rod) + ', ' +
        (tint.sat + near * tint.satNear).toFixed(0) + '%, ' +
        (58 + near * 26).toFixed(0) + '%, ' +
        (0.22 + near * 0.6).toFixed(3) + ')';

      rr(ctx, -len, -thick / 2, len * 2, thick, thick / 2);
      if (branch) {
        ctx.save();
        ctx.translate(len * 0.55, 0);
        ctx.rotate(-0.62);
        rr(ctx, 0, -thick / 2, len * 0.8, thick, thick / 2);
        ctx.restore();
      }
      ctx.restore();
    }

    ctx.shadowBlur = 0;
    for (var j = 0; j < Math.round(n / 3); j++) {
      ctx.beginPath();
      ctx.fillStyle = tint.mote + (0.1 + rnd() * 0.3).toFixed(3) + ')';
      ctx.arc(rnd() * w, rnd() * h, rnd() * Math.min(w, h) * 0.008 + 0.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function rr(ctx, x, y, w, h, r) {
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(x, y, w, h, r);
    else ctx.rect(x, y, w, h);
    ctx.fill();
  }

  function seedOf(text) {
    var n = 0;
    for (var i = 0; i < text.length; i++) n = (n * 31 + text.charCodeAt(i)) % 2147483647;
    return n || 7;
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-drb-strain-close]');
    if (closer) {
      var own = closer.closest('dialog');
      if (own) own.close();
      return;
    }

    var back = event.target.closest('[data-drb-strain-panel]');
    if (back && event.target === back) {
      back.close();
      return;
    }

    var hit = event.target.closest('[data-drb-strain]');
    if (!hit) return;

    var section = hit.closest('.drb-strains');
    var panel = section && section.querySelector('[data-drb-strain-panel]');
    if (!panel || typeof panel.showModal !== 'function') return;

    var title = panel.querySelector('[data-drb-strain-title]');
    var fields = panel.querySelector('[data-drb-strain-fields]');
    var name = hit.querySelector('.drb-strains__nm');

    /* Nodes cloned, never innerHTML: keeps merchant markup out of re-parsed strings (D-0614) */
    if (title && name) {
      title.textContent = '';
      title.appendChild(name.cloneNode(true));
    }

    if (fields) {
      fields.textContent = '';
      var store = hit.parentNode.querySelector('template');
      if (store && store.content) fields.appendChild(store.content.cloneNode(true));
    }

    var canvas = panel.querySelector('[data-drb-strain-canvas]');
    panel.showModal();
    /* Paint after showModal: a closed dialog has no box, so the canvas is blank (D-0615) */
    if (canvas) {
      paint(canvas, hit.getAttribute('data-shape'), seedOf(name ? name.textContent : 'x'));
    }
  });

  var HINT_STEP = 2200;
  var HINT_REST = 4000;
  var HINT_ROWS = 0;
  var LABEL_LEAD_ONLY = true;

  function armHint(section) {
    var rows = [].slice.call(section.querySelectorAll('[data-drb-strain]'));
    if (HINT_ROWS > 0) rows = rows.slice(0, HINT_ROWS);
    if (!rows.length) return;

    var timer = null;
    var i = 0;
    var stopped = false;
    var inView = false;
    var onRow = false;

    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clear() {
      if (timer) clearTimeout(timer);
      timer = null;
    }

    function blank() {
      rows.forEach(function (r) {
        r.classList.remove('is-hint', 'is-hint--lead');
      });
    }

    function paint(n) {
      rows.forEach(function (r, k) {
        r.classList.toggle('is-hint', k === n);
        r.classList.toggle('is-hint--lead', k === n && (!LABEL_LEAD_ONLY || n === 0));
      });
    }

    /* Every reason not to run is checked here, never at the call sites (D-0621) */
    function step() {
      if (stopped || !inView || onRow) return;
      if (i >= rows.length) {
        blank();
        i = 0;
        timer = setTimeout(step, HINT_REST);
        return;
      }
      paint(i);
      if (still) return;
      i += 1;
      timer = setTimeout(step, HINT_STEP);
    }

    function restart() {
      if (stopped || !inView || onRow) return;
      clear();
      i = 0;
      step();
    }

    function stop() {
      if (stopped) return;
      stopped = true;
      clear();
      blank();
    }

    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-drb-strain]')) stop();
    });
    section.addEventListener('focusin', function (e) {
      if (e.target.closest('[data-drb-strain]')) stop();
    });

    /* Touch pointers ignored: pointerleave never fires after a scroll cancels (D-0624) */
    section.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      restart();
    });

    section.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('[data-drb-strain]')) {
        if (onRow) return;
        onRow = true;
        clear();
        blank();
      } else if (onRow) {
        onRow = false;
        restart();
      }
    });

    section.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      onRow = false;
      clear();
      blank();
    });

    section.addEventListener('pointercancel', function () {
      onRow = false;
    });

    if (!('IntersectionObserver' in window)) {
      inView = true;
      return step();
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (stopped) return;
          inView = entry.isIntersecting;
          if (inView) {
            if (!timer) restart();
          } else {
            clear();
            blank();
          }
        });
      },
      { threshold: 0.35 }
    );

    io.observe(section);
  }

  document.querySelectorAll('.drb-strains').forEach(armHint);
})();
